import { gql, useMutation } from '@apollo/client';
import { useSnackbar } from 'hephaestus/web';
import type {
  FileDocumentObjectTypes,
  FileDocumentTypes,
} from '../interfaces/fileDocument';
import { uploadWithRetry } from '../utils/fileUploader';

export type CreateFileInput = {
  objectType: FileDocumentObjectTypes;
  objectId: string;
  fileName: string;
  type: FileDocumentTypes;
  userId?: string;
  name?: string;
  permissionType?: string;
  mediaType?: string;
  sourceId?: string;
  sourceType?: string;
  sharedClient?: boolean;
  sharedWithRoleProfiles?: string[];
  organizationId?: string;
};

export const CREATE_FILE_DOCUMENT = gql`
  mutation createFileDocument($input: CreateFileDocumentInput!) {
    createFileDocument(input: $input) {
      fileDocument {
        id
        name
        fileName
        s3Key
        type
        uploadUrl
      }
    }
  }
`;

export const useFileUpload = () => {
  const [createFileDocument] = useMutation(CREATE_FILE_DOCUMENT);
  const { enqueueSnackbar } = useSnackbar();

  const uploadFile = async (
    file: File,
    input: CreateFileInput,
  ): Promise<string> => {
    const { data } = await createFileDocument({ variables: { input } });
    const uploadUrl = data?.createFileDocument?.fileDocument?.uploadUrl;

    try {
      const uploaded: Response = await uploadWithRetry(uploadUrl, file, 'Form');
      if (!uploaded.ok)
        throw new Error(`${uploaded.status} ${uploaded.statusText}`);
    } catch {
      enqueueSnackbar('Upload failed', { variant: 'error' });
      return '';
    }

    return data.createFileDocument.fileDocument.s3Key;
  };

  return { uploadFile };
};
